export enum ApplicantType {
    SELF = 'self',
    FAMILY = 'family',
    OTHER = 'other',
}

export enum PaymentMethod {
    CARD = 'card',
    APPLE = 'apple',
    GOOGLE = 'google',
}

export enum LinkType {
    BLOCKS = 'BLOCKS',
    IS_BLOCKED_BY = 'IS_BLOCKED_BY',
    IS_DUPLICATE_OF = 'IS_DUPLICATE_OF',
    IS_LINKED_TO = 'IS_LINKED_TO',
}

export enum SyncStatus {
    SYNCED = 'synced',
    SYNC_PENDING = 'sync_pending',
    SYNC_ERROR = 'sync_error',
}

export enum PermitStatusType {
    SUBMITTED = 'SUBMITTED',
    UNDER_REVIEW = 'UNDER_REVIEW',
    PENDING_INFORMATION = 'PENDING_INFORMATION',
    APPROVED = 'APPROVED',
    CONDITIONALLY_APPROVED = 'CONDITIONALLY_APPROVED',
    REFUSED = 'REFUSED',
    ISSUED = 'ISSUED',
    EXPIRED = 'EXPIRED',
}

/**
 * Status types an external system (PSD CityWide) reaches through its own workflow actions, never by
 * a status write. On a connected permit type these are inbound-only: they arrive via sync and the
 * backend refuses agent-initiated moves to them with `permit-status/psd-managed`.
 *
 * Used ONLY to choose which "you cannot change this here" copy to show. The set of *allowed*
 * transitions always comes from `allowedStatusTransitions` on the permit-details response — the
 * gate depends on how the permit reached its current status, which this cannot express.
 */
export const PSD_MANAGED_STATUS_TYPES: ReadonlySet<string> = new Set<string>(['APPROVED', 'CONDITIONALLY_APPROVED', 'ISSUED', 'EXPIRED']);

/** `code` values returned by PATCH /permit/admin/permit/:id/status. Branch on these, not on `message`. */
export enum PermitStatusErrorCode {
    /** Target is PSD-managed, or not reachable from the current status. Means the local view is stale. */
    PSD_MANAGED = 'permit-status/psd-managed',
    /** The permit's current status is terminal. Returned as 409 (was 400 before the PSD ownership change). */
    TERMINAL = 'permit-status/terminal',
}

export enum PermitHistoryAction {
    PERMIT_CREATION = 'PERMIT_CREATION',
    STATUS_CHANGE = 'STATUS_CHANGE',
    DEPARTMENT_CHANGE = 'DEPARTMENT_CHANGE',
    ASSIGNMENT_CHANGE = 'ASSIGNMENT_CHANGE',
    MESSAGE_SENT = 'MESSAGE_SENT',
    INTERNAL_COMMENT_ADDED = 'INTERNAL_COMMENT_ADDED',
    INTERNAL_NOTE_UPDATED = 'INTERNAL_NOTE_UPDATED',
    FILE_ADDED = 'FILE_ADDED',
    FILE_REMOVED = 'FILE_REMOVED',
    INTERNAL_FILE_ADDED = 'INTERNAL_FILE_ADDED',
    INTERNAL_FILE_REMOVED = 'INTERNAL_FILE_REMOVED',
    SUBTASK_CREATED = 'SUBTASK_CREATED',
    SUBTASK_COMPLETED = 'SUBTASK_COMPLETED',
    SUBTASK_DELETED = 'SUBTASK_DELETED',
    FEE_PAID = 'FEE_PAID',
    FEE_MARKED_UNPAID = 'FEE_MARKED_UNPAID',
    LINK_CREATED = 'LINK_CREATED',
    LINK_REMOVED = 'LINK_REMOVED',
    TAG_ADDED = 'TAG_ADDED',
    TAG_REMOVED = 'TAG_REMOVED',
    VALIDITY_SET = 'VALIDITY_SET',
    EXPIRED = 'EXPIRED',
    PSD_SYNC = 'PSD_SYNC',
    RENEWAL_CREATED = 'RENEWAL_CREATED',
}
